"use client";
import { Asset as e } from "../assets/Asset.js";
import { AssetSvg as t } from "../assets/AssetSvg.js";
import { jsx as n, jsxs as r } from "react/jsx-runtime";
import { useId as i } from "react";
//#region src/components/flags/JEFlag.tsx
var a = (e) => {
	let a = i();
	return /* @__PURE__ */ r(t, {
		viewBox: "0 0 24 24",
		fill: "none",
		...e,
		children: [/* @__PURE__ */ r("g", {
			clipPath: `url(#${a}-clip0_103_117)`,
			children: [
				/* @__PURE__ */ n("mask", {
					id: `${a}-path-1-inside-1_103_117`,
					fill: "white",
					children: /* @__PURE__ */ n("path", { d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z" })
				}),
				/* @__PURE__ */ n("path", {
					d: "M-6 0H30V24H-6V0Z",
					fill: "white"
				}),
				/* @__PURE__ */ n("path", {
					d: "M15.1789 12L30 2.1193V0H26.8211L12 9.8807L-2.82105 0H-6V2.1193L8.82105 12L-6 21.8807V24H-2.82105L12 14.1193L26.8211 24H30V21.8807L15.1789 12Z",
					fill: "#D80027"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.4 3.1298L11.9649 3.52278L13.5298 3.1298L13.8105 1.66314L12.7649 2.11928L11.9649 1.03857L11.1649 2.11928L10.1193 1.66314L10.4 3.1298Z",
					fill: "#FFDA44"
				}),
				/* @__PURE__ */ n("path", {
					d: "M10.4 3.12981C10.4 3.12981 10.1193 4.03507 10.1193 5.22805C10.1193 7.18595 11.9649 8.1263 11.9649 8.1263C11.9649 8.1263 13.8105 7.03858 13.8105 5.22805C13.8105 4.14735 13.5298 3.12981 13.5298 3.12981C13.5298 3.12981 12.9614 2.77893 11.9649 2.77893C10.9684 2.77893 10.4 3.12981 10.4 3.12981Z",
					fill: "#D80027"
				})
			]
		}), /* @__PURE__ */ n("defs", { children: /* @__PURE__ */ n("clipPath", {
			id: `${a}-clip0_103_117`,
			children: /* @__PURE__ */ n("path", {
				d: "M0 12C0 5.37258 5.37258 0 12 0C18.6274 0 24 5.37258 24 12C24 18.6274 18.6274 24 12 24C5.37258 24 0 18.6274 0 12Z",
				fill: "white"
			})
		}) })]
	});
}, o = {
	12: {
		Artwork: a,
		width: 12,
		height: 12
	},
	16: {
		Artwork: a,
		width: 16,
		height: 16
	},
	20: {
		Artwork: a,
		width: 20,
		height: 20
	},
	24: {
		Artwork: a,
		width: 24,
		height: 24
	}
}, s = ({ size: t = 16, ...r }) => /* @__PURE__ */ n(e, {
	source: o[t],
	frame: "circle",
	...r
});
//#endregion
export { s as JEFlag };
